// extracted by mini-css-extract-plugin
module.exports = {"layout":"SearchScreen_layout___pVOr","search":"SearchScreen_search___1d10"};